import { N14_01 } from "./N14_01";

export const N14 = {
    "columns": 4,
    "rows": 1,
    "visual": {
        "id": 1,
        "type": "bar",
        "colorTheme": 'colorTheme1',
        "title": "ADVANCED CALLS",
        "orientation": "vertical",
        "xAxis": "",
        "yAxis": "",
        "binding": {
            "data": {
                "series": [
                    {
                        "name": 'Count',
                        "value": 'TotalCount',
                        "type": 'column'

                    }
                ],
                "title": 'SubCycle',
                "endpoint": "SFE_N14",
                "parameters": [
                    { "key": "CycleCode", "value": "1" },
                    { "key": "CycleYear", "value": "2025" },
                ]
            },
            "context": {
                "point": {
                    "onClick": N14_01
                }
            }
        }
    }
}